import React from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";

import ShimmerLoader from "../../../Common/ShimmerLoader";
import Pagination from "../../ShopServices/Orders/components/Pagination";

import { useAdsAuditLogs } from "../hooks";
import type { AdsAuditLog } from "../../../api/ads";

import { AdsAuditLogTable } from "./components/AdsAuditLogTable";

import "./AuditLogs.css";

const AuditLogsPage: React.FC = () => {
  const { functions, values, loading } = useAdsAuditLogs();

  const pageSize = values.params.pageSize ?? 10;
  const currentPage = values.params.pageNum ?? 1;
  const totalCount = values.totalCount ?? 0;

  return (
    <div className="page-content">
      <Container fluid>
        <div className="audit-page-header">
          <h1 className="audit-page-title">Audit Logs</h1>
          <p className="audit-page-subtitle">Track all system and user actions</p>
        </div>

        <Row>
          <Col>
            {loading.listLoading ? (
              <ShimmerLoader type="table" rows={6} />
            ) : values.logs.length > 0 ? (
              <AdsAuditLogTable logs={values.logs as AdsAuditLog[]} />
            ) : (
              <div className="audit-empty">
                <p className="audit-empty__text">No audit logs found.</p>
              </div>
            )}

            {!loading.listLoading && totalCount > 0 && values.totalPages > 1 && (
              <Pagination
                currentPage={currentPage}
                totalPages={values.totalPages}
                totalCount={totalCount}
                pageSize={pageSize}
                onPageChange={(page) => functions.setPageNum(page)}
                onPageSizeChange={(size) => functions.setPageSize(size)}
              />
            )}
          </Col>
        </Row>

        {values.error && (
          <Alert variant="danger" dismissible onClose={() => functions.fetchLogs()} className="mt-3">
            {values.error}
          </Alert>
        )}
      </Container>
    </div>
  );
};

export default AuditLogsPage;
